import { BaseContent, Button, ModalBox, useModalContext } from '@fourthwall/components';
import React from 'react';
export const UnsavedChangesModal = ({ onSave, onDiscard }) => {
    const { close } = useModalContext();
    return (React.createElement(ModalBox, { title: "Would you like to save your changes?", buttons: [
            React.createElement(Button, { label: "Cancel", onClick: close }),
            React.createElement(Button, { label: "Discard changes", appearance: "destructive", onClick: () => {
                    onDiscard();
                    close();
                } }),
            React.createElement(Button, { label: "Save changes", appearance: "primary", onClick: () => {
                    onSave();
                    close();
                } }),
        ], onClose: close },
        React.createElement(BaseContent, null,
            React.createElement("p", null, "If you leave this page, all unsaved changes will be discarded."))));
};
